<template>
    <div class="coverinfodetails">
        <v-layout row>
            <v-flex xs11 offset-xs1>
                <v-layout row>
                    <v-flex xs10>
                        <span class="header-title-details">{{$t('Claim.RequestClaim.SUMMARY_CLAIM_SUBMISSION_SUMMARY_TITLE')}}</span>
                    </v-flex>
                    <v-flex xs2>
                         <span class="right">
                            <a v-on:click='closeExtendedMode' >  <span class="icon-close"></span></a>
                        </span>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
         <v-layout row>
           <v-flex xs11 offset-xs1>
              <div class="invoicedetails">
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_INVOICE_NUMBER_FIELD_NAME')}} </v-label>
                    <p class="invoicenumber">{{cover.invoice.number}}</p>
              </div>
           </v-flex>
        </v-layout>
         <v-layout row>
           <v-flex xs11 offset-xs1>
               <ClaimDetails />
           </v-flex>
        </v-layout>
         <v-layout row>
           <v-flex xs11 offset-xs1>
               <InvoiceMoreDetails />
           </v-flex>
        </v-layout>
        <v-layout row>
           <v-flex xs11 offset-xs1>
               <CoverDetailsInfo />
           </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs11 offset-xs1>
             <br/>
             <p v-if="error" class="errorMessage">{{$t('Claim.RequestClaim.CLAIM_CREATION_ERROR')}}</p>
             <br/>
             <p v-if="errorExternal" class="errorMessage">{{$t('Claim.RequestClaim.SERVICE_UNAVAILABLE_ERROR')}}</p>

           </v-flex>
        </v-layout>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import ClaimDetails from '@/components/cover/claim/ClaimDetails'
import InvoiceMoreDetails from '@/components/cover/details/InvoiceMoreDetails'
import CoverDetailsInfo from '@/components/cover/details/CoverDetailsInfo'

export default {
  data () {
    return {
      error: false,
      errorExternal: false
    }
  },
  methods: {
    closeExtendedMode () {
      this.$parent.initializeAndCloseExtendedMode()
    }
  },
  computed: {
    ...mapState('cover', ['cover'])
  },
  components: {
    ClaimDetails,
    InvoiceMoreDetails,
    CoverDetailsInfo
  }
}
</script>
